// Puente hacia el banner de AdMob que dibuja la app Android (MainActivity.kt,
// WebAppInterface.setBannerVisible) debajo del WebView. AdSense no se muestra
// dentro de la app, así que ahí el anuncio lo pone AdMob de forma nativa.
// La web decide cuándo: solo en pantallas que ya tienen contenido, igual que
// los bloques de AdSense.
import { useEffect } from "react";

export function isNativeBannerAvailable() {
  return (
    typeof window !== "undefined" &&
    typeof window.Android !== "undefined" &&
    typeof window.Android.setBannerVisible === "function"
  );
}

const setNativeBannerVisible = (visible) => {
  try {
    window.Android.setBannerVisible(visible);
  } catch (e) {
    console.error("Error mostrando el banner de AdMob:", e);
  }
};

// Muestra el banner nativo mientras el componente esté montado.
export function useNativeBanner(enabled = true) {
  useEffect(() => {
    if (!enabled || !isNativeBannerAvailable()) return undefined;
    setNativeBannerVisible(true);
    return () => setNativeBannerVisible(false);
  }, [enabled]);
}
